import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/button/Button';
import { PermissionLockIcon } from '../components/icons';

const NoAccessPage = ({ handleLogout }: { handleLogout?: () => void }) => {
    const navigate = useNavigate();

    return (
        <div className=' w-[full] flex justify-center items-center h-[80vh] flex-col gap-4'>
            <PermissionLockIcon />
            <h3 className='text-[18px] font-bold text-center'>
                {handleLogout ? 'Permission needed' : '404 - Page Not Found'}
            </h3>
            <p className='w-[30%] text-center text-midnightHaze text-[14px]'>
                {handleLogout
                    ? 'You currently do not have permission to view this page. Contact your admin for assistance'
                    : 'Sorry, the page you are looking for does not exist.'}
            </p>

            {handleLogout ? (
                <Button text='Logout' onClick={handleLogout} size='sm' />
            ) : (
                <Button
                    text='Go to Home'
                    onClick={() => navigate('/dashboard')}
                    size='sm'
                />
            )}
        </div>
    );
};

export default NoAccessPage;
